<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
/*@import '../node_modules/@fortawesome/fontawesome-free/css/fontawesome.min.css';
@import '../node_modules/@fortawesome/fontawesome-free/css/solid.min.css';
@import '../node_modules/@fortawesome/fontawesome-free/css/brands.min.css';*/
@import '../node_modules/vue-image-lightbox/dist/vue-image-lightbox.min.css';
@import '../node_modules/slick-carousel/slick/slick.css';
@import '../node_modules/slick-carousel/slick/slick-theme.css';
@import 'assets/css/blocco.css';
@import 'assets/css/app.css';
@import 'assets/css/grid.css';
</style>



// WEBPACK FOOTER //
// src/App.vue